import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Search/utils.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import { isNotEmpty } from '@gmini/utils';
import { getNode } from "../../classifier-service";
import { apiToNodeTypeMap } from "../../classifier-service/adapters";
import { isBimNode, isReferenceNode } from "../../classifier-service/Node";
import { findFlatNodesByKey } from "../ClassifierTree/utils";
export function getNodes(type, nodes) {
  switch (type) {
    case 'BimModelNode':
      return nodes.BimModelNode;

    case 'BimCategoryNode':
      return nodes.BimCategoryNode;

    case 'BimFamilyNode':
      return nodes.BimFamilyNode;

    case 'BimStandardSizeNode':
      return nodes.BimStandardSizeNode;

    case 'BimElementNode':
      return nodes.BimElementNode;

    default:
      throw new Error("Incorrect BimNode type: ".concat(type));
  }
}
export function findElementRefs(nodes, refs, buildKeyFunc) {
  return Object.values(refs).filter(function (ref) {
    return (ref === null || ref === void 0 ? void 0 : ref.element) && nodes.some(function (node) {
      return buildKeyFunc(node) === buildKeyFunc(ref.element);
    });
  }).filter(isNotEmpty);
}
export function getMatch(path, buildKeyFunc, ref) {
  var keyMap = {};
  path.forEach(function (key) {
    return ref && key === buildKeyFunc(ref) ? keyMap = _objectSpread(_objectSpread({}, keyMap), {}, _defineProperty({}, key, 'fullMatch')) : keyMap = _objectSpread(_objectSpread({}, keyMap), {}, _defineProperty({}, key, 'match'));
  });
  return keyMap;
}
export function getSourceElements(searchNode, nodeMap, getKey, apiMap) {
  return Object.values(nodeMap).filter(isNotEmpty).filter(function (node) {
    var _searchNode$source, _node$source;

    return searchNode.source ? (_searchNode$source = searchNode.source) === null || _searchNode$source === void 0 ? void 0 : _searchNode$source.some(function (_ref) {
      var sourceId = _ref.sourceId,
          sourceType = _ref.sourceType;
      return getKey({
        id: sourceId,
        type: apiMap[sourceType]
      }) === getKey(node);
    }) : node === null || node === void 0 ? void 0 : (_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.some(function (node) {
      return getKey({
        id: node.sourceId,
        type: apiMap[node.sourceType]
      }) === getKey(searchNode);
    });
  }).filter(isNotEmpty);
}
export function findMatchedElements(searchedNode, tree, referenceNodes, getKey, parentNode) {
  var searchMap = {};
  findElementRefs(parentNode ? [parentNode, searchedNode] : [searchedNode], referenceNodes, getKey).forEach(function (ref) {
    findFlatNodesByKey(getKey(ref), tree).forEach(function (_ref2) {
      var path = _ref2.path;
      searchMap = _objectSpread(_objectSpread({}, searchMap), getMatch(path, getKey, parentNode ? searchedNode : ref));
    });
  });
  findFlatNodesByKey(getKey(parentNode ? parentNode : searchedNode), tree).forEach(function (_ref3) {
    var path = _ref3.path;
    searchMap = _objectSpread(_objectSpread({}, searchMap), getMatch(path, getKey, searchedNode));
  });
  return searchMap;
}
export function getModelId(node) {
  return node.type === 'BimModelNode' ? node.id : node.modelId;
}
export function getSourceElement(searchNode, nodeMap, getKey) {
  return Object.values(nodeMap).find(function (node) {
    var _node$source2;

    return node === null || node === void 0 ? void 0 : (_node$source2 = node.source) === null || _node$source2 === void 0 ? void 0 : _node$source2.some(function (node) {
      return getKey({
        id: node.sourceId,
        type: apiToNodeTypeMap[node.sourceType]
      }) === getKey(searchNode);
    });
  });
}
export function findFromAssemblyElementNode(parentNode, nodes, tree, node, getKey) {
  var keyMap = {};
  var parentSourceElements = parentNode.source || [];
  var elementSourceElements = (node === null || node === void 0 ? void 0 : node.source) || [];
  var sourceNodes = parentSourceElements.map(function (ref) {
    return getNode(nodes, {
      id: ref.sourceId,
      type: apiToNodeTypeMap[ref.sourceType]
    });
  }).filter(isNotEmpty).filter(function (node) {
    return elementSourceElements.some(function (el) {
      return el.modelId === getModelId(node);
    });
  });
  var fullMatchElements = elementSourceElements.map(function (ref) {
    return getNode(nodes, {
      id: ref.sourceId,
      type: apiToNodeTypeMap[ref.sourceType]
    });
  }).filter(isNotEmpty);
  sourceNodes.forEach(function (ref) {
    keyMap = _objectSpread(_objectSpread({}, keyMap), findMatchedElements(node, tree, nodes.ReferenceNode, getKey, ref));
  });
  fullMatchElements.forEach(function (node) {
    keyMap = _objectSpread(_objectSpread({}, keyMap), {}, _defineProperty({}, getKey(node), 'fullMatch'));
  });
  return node ? _objectSpread(_objectSpread({}, keyMap), {}, _defineProperty({}, getKey(node), 'fullMatch')) : keyMap;
}
export function createNodeSearchModel(nodes, tree, buildKeyFunc) {
  var searchModelElementNode = function searchModelElementNode(node) {
    return findMatchedElements(node, tree, nodes.ReferenceNode, buildKeyFunc);
  };

  var searchInParentDynamicGroupNode = function searchInParentDynamicGroupNode(searchedElement, parentDynamicGroups) {
    var searchMap = {};
    parentDynamicGroups.forEach(function (node) {
      var targetChild = node === null || node === void 0 ? void 0 : node.children.filter(function (child) {
        return child.type === 'DynamicBimElementReferenceNode';
      }).find(function (child) {
        var childNode = getNode(nodes, child);

        if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) !== 'DynamicBimElementReferenceNode') {
          return;
        }

        return buildKeyFunc(childNode.element) === buildKeyFunc(searchedElement) ? childNode.element : null;
      });

      if (targetChild) {
        searchMap = _objectSpread(_objectSpread({}, searchMap), {}, _defineProperty({}, buildKeyFunc(targetChild), 'fullMatch'));
      }

      findFlatNodesByKey(buildKeyFunc(node), tree).forEach(function (_ref4) {
        var path = _ref4.path;
        searchMap = _objectSpread(_objectSpread({}, searchMap), getMatch(path, buildKeyFunc));
      });
    });
    return searchMap;
  };

  var searchElementNode = function searchElementNode(element, parentNode, searchedRefs) {
    var matchedElements = findMatchedElements(element, tree, nodes.ReferenceNode, buildKeyFunc, parentNode);
    var searchedRefsMatched = searchedRefs === null || searchedRefs === void 0 ? void 0 : searchedRefs.reduce(function (acc, ref) {
      var searchMap = {};

      if (!ref.parentGroupId) {
        return acc;
      }

      var group = nodes.UserClassifierGroupNode[ref.parentGroupId];

      if (group) {
        findFlatNodesByKey(buildKeyFunc(group), tree).forEach(function (_ref5) {
          var path = _ref5.path;
          searchMap = _objectSpread(_objectSpread(_objectSpread({}, searchMap), getMatch(path, buildKeyFunc)), {}, _defineProperty({}, buildKeyFunc(ref), 'fullMatch'));
        });
      }

      return _objectSpread(_objectSpread({}, acc), searchMap);
    }, {});
    return _objectSpread(_objectSpread(_objectSpread({}, matchedElements), searchedRefsMatched), {}, _defineProperty({}, buildKeyFunc(element), 'fullMatch'));
  };

  var searchAssemblyElementNode = function searchAssemblyElementNode(element, parentNode) {
    var searchMap = {};

    if (element.source) {
      searchMap = _objectSpread(_objectSpread({}, searchMap), findFromAssemblyElementNode(parentNode, nodes, tree, element, buildKeyFunc));
    }

    var parentElement = getSourceElement(parentNode, getNodes(parentNode.type, nodes), buildKeyFunc);
    var searchedElement = getSourceElement(element, getNodes(element.type, nodes), buildKeyFunc);

    if (!parentElement) {
      return searchMap;
    }

    findFlatNodesByKey(buildKeyFunc(parentElement), tree).forEach(function (_ref6) {
      var path = _ref6.path;
      searchMap = _objectSpread(_objectSpread({}, searchMap), getMatch(path, buildKeyFunc));
    });

    if (searchedElement) {
      findFlatNodesByKey(buildKeyFunc(searchedElement), tree).forEach(function (_ref7) {
        var path = _ref7.path;
        searchMap = _objectSpread(_objectSpread({}, searchMap), getMatch(path, buildKeyFunc, searchedElement));
      });
    }

    return searchMap;
  };

  var searchAssemblyModelElementNode = function searchAssemblyModelElementNode(node) {
    var searchMap = {};
    var nodesByType = getNodes(node.type, nodes);
    var sourceElements = getSourceElements(node, nodesByType, buildKeyFunc, apiToNodeTypeMap);
    sourceElements.forEach(function (ref) {
      searchMap = _objectSpread(_objectSpread({}, searchMap), findMatchedElements(ref, tree, nodes.ReferenceNode, buildKeyFunc));
    });
    return searchMap;
  };

  var searchInDynamicGroupNodes = function searchInDynamicGroupNodes(bimNode, dynamicGroups) {
    var searchMap = {};
    dynamicGroups.filter(function (dynamicGroup) {
      var _dynamicGroup$source;

      return dynamicGroup.source && ((_dynamicGroup$source = dynamicGroup.source) === null || _dynamicGroup$source === void 0 ? void 0 : _dynamicGroup$source.type) !== 'UserClassifierGroup' && buildKeyFunc({
        id: dynamicGroup.source.id,
        type: apiToNodeTypeMap[dynamicGroup.source.type]
      }) === buildKeyFunc(bimNode);
    }).forEach(function (node) {
      findFlatNodesByKey(buildKeyFunc(node), tree).forEach(function (_ref8) {
        var path = _ref8.path;
        searchMap = _objectSpread(_objectSpread({}, searchMap), getMatch(path, buildKeyFunc, node));
      });
    });
    return searchMap;
  };

  return {
    searchAssemblyElementNode: searchAssemblyElementNode,
    searchElementNode: searchElementNode,
    searchAssemblyModelElementNode: searchAssemblyModelElementNode,
    searchModelElementNode: searchModelElementNode,
    searchInDynamicGroupNodes: searchInDynamicGroupNodes,
    searchInParentDynamicGroupNode: searchInParentDynamicGroupNode
  };
}
export function getBimNode(node, nodes) {
  if (isBimNode(node)) {
    return node;
  } else if (isReferenceNode(node)) {
    return getNode(nodes, node.element);
  } else if (node.type === 'DynamicGeneratedGroupNode' && node.source) {
    var bimNode = getNode(nodes, {
      id: node.source.id,
      type: apiToNodeTypeMap[node.source.type]
    });
    return bimNode && isBimNode(bimNode) ? bimNode : null;
  } else if (node.type === 'DynamicBimElementReferenceNode') {
    return getNode(nodes, node.element);
  }

  return null;
}